import {
    CHANGE_ELEMENTS_PER_ROW,
    CHANGE_IS_READY,
    CHANGE_IS_REMOVING,
    GET_ANIMALS,
    GET_ANIMALS_BY_FILTER,
    IMAGE_ERROR,
    IMAGE_LOADED,
    RESET_READY,
    SAVE_INFO_RAZA
} from '../actions/actionsAnimalList'

const initialState = {
    list: [],
    totalRecords: 0,
    pag: 0,
    elementsPerRow: 0,
    elementsPerPage: 0,
    imagesOnPage: 0,
    imagesLoaded: 0,
    imagesError: 0,
    isReady: false,
    isRemoving: false,
    imagesurl: []
};

export function reducerAnimalList(state = initialState, action) {

    switch (action.type) {
        case GET_ANIMALS_BY_FILTER:
            // console.log("reducerAnimalList::reducerAnimalList(action.type = " + action.type + ")")
            return Object.assign({}, state, {
                list: action.payload.result,
                totalRecords: action.payload.totalRecords,
                metadata: action.payload.metadata,
            });
        case GET_ANIMALS:
            return Object.assign({}, state, {
                list: action.payload.result,
                totalRecords: action.payload.totalRecords,
                pag: action.payload.pag,
                elementsPerRow: action.payload.elementsPerRow,
                elementsPerPage: action.payload.elementsPerPage,
                imagesOnPage: action.payload.imagesOnPage,
                imagesLoaded: action.payload.imagesLoaded,
                imagesError: action.payload.imagesError,
                isReady: action.payload.isReady,
                imagesurl: action.payload.imagesurl
            });

        case SAVE_INFO_RAZA:
            return Object.assign({}, state, {
                infoRaza: action.payload
            });
        case CHANGE_ELEMENTS_PER_ROW:
            return Object.assign({}, state, {
                elementsPerRow: action.payload.elementsPerRow
            });
        case IMAGE_LOADED:
            return Object.assign({}, state, {
                imagesLoaded: action.payload.imagesLoaded
            });
        case IMAGE_ERROR:
            return Object.assign({}, state, {
                imagesError: action.payload.imagesError
            });
        case CHANGE_IS_READY:
            return Object.assign({}, state, {
                isReady: action.payload.isReady
            });
        case CHANGE_IS_REMOVING:
            return Object.assign({}, state, {
                isRemoving: action.payload.isRemoving
            });
        case RESET_READY:
            return Object.assign({}, state, {
                isReady: action.payload.isReady,
                imagesLoaded: action.payload.imagesLoaded,
                imagesError: action.payload.imagesError
            });
        default:
            return state
    }
}